import { PACKER_ADDED, PACKER_EDIT, PACKER_FETCHED, PACKER_REMOVED } from '../actions/actions_packers';

function replacePackersPricingGroup(allPackersPricingGroups, editedPackersPricingGroup) {
  const newPackersPricingGroups = [];
  allPackersPricingGroups.forEach(element => {
    if (element.id === editedPackersPricingGroup.id) {
      newPackersPricingGroups.push(editedPackersPricingGroup);
    } else {
      newPackersPricingGroups.push(element);
    }
  });
  return newPackersPricingGroups;
}

function removePackersPricingGroup(allPackersPricingGroups, removedPackersPricingGroup) {
  const newPackersPricingGroups = [];
  allPackersPricingGroups.forEach(element => {
    if (element.id !== removedPackersPricingGroup.id) {
      newPackersPricingGroups.push(element);
    }
  });
  return newPackersPricingGroups;
}

const packer = (packer_ = [], action) => {
  const copy = JSON.parse(JSON.stringify(packer_));

  switch (action.type) {
    case PACKER_FETCHED:
      return action.payload;
    case PACKER_ADDED:
      copy.push(action.payload);
      return copy;
    case PACKER_EDIT:
      return replacePackersPricingGroup(copy, action.payload);
    case PACKER_REMOVED:
      return removePackersPricingGroup(copy, action.payload);
    default:
      return packer_;
  }
};

export default packer;
